import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TractorsHistoryDetailsGridComponent } from './tractors-history-details-grid.component';
import {DxDataGridModule, DxLoadPanelModule, DxScrollViewModule} from 'devextreme-angular';



@NgModule({
  declarations: [TractorsHistoryDetailsGridComponent],
  imports: [
    CommonModule,
    DxScrollViewModule,
    DxLoadPanelModule,
    DxDataGridModule
  ],
  exports: [TractorsHistoryDetailsGridComponent]
})
export class TractorsHistoryDetailsGridModule { }
